<template>
  <div class="football-manual-stats-wrapper">
    <section class="fullwidth">
      <div :class="[item[1]]" v-for="item in [
        ['home', 'part-first'],
        ['away', 'part-last'],]"
        :key="item.$index">
        <ul>
          <li>
            <span class="silent" v-if="item[0] == 'home'">Tackels </span>
            {{match.stats.tackles[item[0]]}}
          </li>
            <li><span class="silent" v-if="item[0] == 'home'">Shot on target </span>
          {{match.stats.shot_on_target[item[0]]}} </li>
          <li>
            <span class="silent" v-if="item[0] == 'home'">Total passes</span>
          {{match.stats.passes[item[0]]}}
          </li>
          <li>
            <span class="silent" v-if="item[0] == 'home'">Goal saved</span>
          {{match.stats.goal_saved[item[0]]}}
          </li>

        </ul>
      </div>
    </section>
    <section class="fullwidth stats-table">
      <table>
        <col>
        <col>
        <col>
        <colgroup span="4"></colgroup>
        <colgroup span="3"></colgroup>
        <colgroup span="2"></colgroup>
        <colgroup span="3"></colgroup>
        <!-- <tr class="head">
          <th rowspan="2"></th>
          <th colspan="2"></th>
          <th colspan="4" scope="colgroup">Goal</th>
          <th colspan="3" scope="colgroup">Card</th>
          <th colspan="2" scope="colgroup">Foul</th>
          <th colspan="3" scope="colgroup">Penalty</th>
        </tr> -->
        <tr class="head second-row">
          <th rowspan="1"></th>
          <th scope="col">Total Passes</th>
          <th scope="col">Short On Target</th>
          <th scope="col">Tackles</th>
          <th scope="col">Goal Saved</th>
        </tr>
        <template v-for="team in [match.info.home, match.info.away]">
          <template v-for="role in roleOrder">
            <tr>
              <th class="subtitle" colspan="15">{{team.name}} - {{role.name}}</th>
            </tr>
            <tr class="stats-row"
              v-for="playerKey in match.teams[team.key].players"
              xxif="match.players[playerKey].stats.minutes_played > 0 && match.players[playerKey].role == role.key"
              v-if="shouldShow(match.players[playerKey], role)"
              :key="playerKey">
              <th
                scope="row"
                @click="onPlayerSelected(playerKey)"
                class="clickable">{{match.players[playerKey].jersey_name}} <small v-if="role.keys == null">{{match.players[playerKey].role}}</small></th>
              <td v-if="match.players[playerKey].stats.passes">{{match.players[playerKey].stats.passes}}</td><td v-else>-</td>
              <td v-if="match.players[playerKey].stats.shot_on_target">{{match.players[playerKey].stats.shot_on_target}}</td>
              <td v-else>-</td>
              <td v-if="match.players[playerKey].stats.tackles">{{match.players[playerKey].stats.tackles}}</td><td v-else>-</td>
              <td v-if="match.players[playerKey].stats.goal.saved">{{match.players[playerKey].stats.goal.saved}}</td><td v-else>-</td>
            </tr>
          </template>
        </template>
      </table>
    </section>
  </div>
</template>
<script>
export default {
  props: {
    match: Object
  },
  data () {
    return {
      roleOrder: [
        { keys: ['goalkeeper'], name: 'Goalkeepers' },
        { keys: ['defender'], name: 'Defenders' },
        { keys: ['midfielder'], name: 'Midfielder' },
        { keys: ['striker'], name: 'Strikers' },
        { keys: null, name: 'Others' }
      ]
    }
  },
  methods: {
    shouldShow (player, for_role) {
      if (player.stats.minutes_played > 0) {
        const player_role = player.role.value
        if (for_role.keys == null) {
          let allRoles = []
          this.roleOrder.forEach((role) => {
            if (role.keys != null) {
              allRoles = allRoles.concat(role.keys)
            }
          })
          if (allRoles.indexOf(player_role) == -1) {
            return true
          }
        } else {
          if (for_role.keys.indexOf(player_role) > -1) {
            return true
          }
        }
      }
      return false
    },
    onPlayerSelected (playerKey) {
      this.$emit('playerSelected', playerKey)
    }
  }
}
</script>
